import Content from "../components/Blog/Content";
import React, { FC } from 'react';
import { Button, Col, Container, Row } from "react-bootstrap";
import { ArticleType } from "../models/article.model";
import Bookmarks from "../components/Blog/Bookmarks";
import { Link, useNavigate } from "react-router-dom";
import { isAdminAuthenticated } from "../common/auth";
import AdminLoginModal from "../components/Blog/AdminLoginModal";


interface IBlogState {
    posts?: ArticleType[];
    handleBookmark: (post: ArticleType) => void;
    handleRemoveBookmark: (post: ArticleType) => void;
}

const Blog: FC<IBlogState> = ({ posts, handleBookmark, handleRemoveBookmark }) => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = React.useState('');
    const [showAuthModal, setShowAuthModal] = React.useState(false);

    const handleWritePost = React.useCallback(() => {
        if (isAdminAuthenticated()) {
            navigate('/blog/editor');
        } else {
            setShowAuthModal(true);
        }
    }, [navigate]);

    const normalizedPosts = React.useMemo(() => posts ?? [], [posts]);
    const bookmarks = React.useMemo(() => normalizedPosts.filter((post) => post.Bookmark), [normalizedPosts]);
    const filteredPosts = React.useMemo(() => {
        const query = searchTerm.trim().toLowerCase();
        if (!query) {
            return normalizedPosts;
        }

        return normalizedPosts.filter((post) =>
            post.Title.toLowerCase().includes(query) ||
            post.Body.toLowerCase().includes(query)
        );
    }, [normalizedPosts, searchTerm]);

    return (
        <>
            <Container className='mt-5 blog-page py-4' fluid="md">
                <Row className="align-items-end g-3 blog-hero">
                    <Col md={8}>
                        <h2 className="blog-title">Stories From Masjid-e-Taqwa</h2>
                        <p className="blog-subtitle">Read updates, preserve knowledge, and bookmark your must-read posts.</p>
                    </Col>
                    <Col md={4} className="d-flex justify-content-md-end gap-2 flex-wrap">
                        <Button size="sm" variant="primary" onClick={handleWritePost}>Write Post</Button>
                        <Link className="btn btn-outline-primary btn-sm" to="/blog/bookmark">Bookmarks ({bookmarks.length})</Link>
                    </Col>
                </Row>

                <Row className="mt-3 g-3">
                    <Col>
                        <input
                            className="form-control"
                            type="search"
                            placeholder="Search blog posts"
                            value={searchTerm}
                            onChange={(event) => setSearchTerm(event.target.value)}
                            aria-label="Search blog posts"
                        />
                    </Col>
                </Row>
                <Row id="blog-posts" className='g-4 mt-1'>
                    <Col lg={4}>
                        <aside className="blog-sidebar-card">
                            <h5 className="mb-3">Pinned Bookmarks</h5>
                            <Bookmarks bookmarks={bookmarks} />
                        </aside>
                    </Col>
                    <Col lg={8}>
                        <Content posts={filteredPosts} handleBookmark={handleBookmark} handleRemoveBookmark={handleRemoveBookmark} />
                    </Col>
                    
                </Row>
            </Container>
            <AdminLoginModal
                show={showAuthModal}
                onHide={() => setShowAuthModal(false)}
                onSuccess={() => { setShowAuthModal(false); navigate('/blog/editor'); }}
            />
        </>
    );
}
export default Blog;